import * as React from 'react';
import { RootStore, withInjectedRootStore } from 'providers';
import { SentryLogger } from 'services/SentryLogger';
import s from './ErrorBoundaries.scss';
import { DesktopErrorBoundary } from './DesktopErrorBoundary';

interface ErrorBoundaryProps {
  rootStore: RootStore;
}

class ErrorBoundaryComp extends React.Component<
  ErrorBoundaryProps,
  { hasError: boolean }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    SentryLogger.logError(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={s.errorBoundary}>
          <div className={s.antena}></div>
          <DesktopErrorBoundary />
        </div>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withInjectedRootStore(ErrorBoundaryComp);
